export default "__VITE_ASSET__5f8bcaf5__"